import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { FloatCardComponent } from "../../../components/cards";
import PageLayout from "../../../layouts/PageLayout";
import { PaginationComponent } from "../../../components";
import PrayerTableComponent from "../../../components/tables/PrayerTableComponent";
import axios from "axios";

export default function AllPrayerRequests() {
  const { t } = useContext(TranslatorContext);
  const [prayers, setPrayers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    const fetchPrayers = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/prayer-requests?page=${page}`
        );

        const apiData = res.data.data;

        const prayerData = apiData.data.map((item) => ({
          fsf_id: item.person?.f_number,
          name: item.person?.beneficiary_name,
          prayer: item.prayer,
        }));

        setPrayers(prayerData);
        setPagination({
          current_page: apiData.current_page,
          last_page: apiData.last_page,
          total: apiData.total,
        });

        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchPrayers();
  }, [page]);


  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {loading ? "Loading Prayer Requests..." : `Family Prayer Requests`}
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("Prayer Requests")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"All Prayer Requests"}</li>
              </ul>
            </div>
          </div>
        </Col>

        <Col xl={12}>
          <div className="mc-card">
            <Row>

              <Col xl={12}>
                <PrayerTableComponent
                  thead={["FSF ID", "Name", "Prayer", 'Action']}
                  tbody={prayers}
                />

                <PaginationComponent
                  currentPage={pagination.current_page}
                  totalPages={pagination.last_page}
                  onPageChange={(page) => setPage(page)}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
